import React, { Component } from 'react';

import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';

import images from '../../../style/img/flag/images';

class Cards extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            selectedId: '',
            toggleShowMore: null,
        }
    }

    // Toggle show more/less of the selected card
	onToggleShowMore = (selectedId) => {
		return () => {
            if (selectedId != this.state.selectedId) {
                this.setState({ selectedId, toggleShowMore: true })
			} else {
                this.setState({ selectedId: null, toggleShowMore: false })
			}
		}
	}

	// Opens PDF to a specific Country
    onPDFClick = (countryName) => {
		return () => {
			const url = `/osh-barometer/osh-context/osh-authorities/OSH authorities - ${countryName}.pdf`
			window.open(url, "_blank")
		}
	}
    
    // function to trim the passed text
	truncateText = (str, limitNumber) => {
		const replacedText = str.replace(/<\/?[a-z][a-z0-9]*[^<>]*>|<!--.*?-->/img)

		if (replacedText.length > limitNumber) {
			return `${str.substring(0, limitNumber).split(" ").slice(0, -1).join(" ")} <span class="dots" >...</span>`
		} else {
			return str
		}
	}

    render() {
		const { literals, countryData, cardType, idCard } = this.props

		let cardContent;
		if (cardType != "organisation" && cardType != "programme" && cardType != "publication")
		{
			const replacedText = countryData.text2 && literals[`L${countryData.text2}`].replace(/<\/?[a-z][a-z0-9]*[^<>]*>|<!--.*?-->/img);
			cardContent = <React.Fragment >
				<div className="matrix--header--elements">
					<img className="flags--wrapper" src={images[countryData.country.code.toLowerCase()]} />
					<h2 className="country title-section main-color">{literals[`L${countryData.country.literalID}`] }</h2>
				</div>
				<div className="matrix--content--elements">
					<h3 className="">
						{cardType == 'institution' && (
							literals[countryData.check1 && 'L20614' || countryData.check2 && 'L20611' || countryData.check3 && 'L20612' || countryData.check4 && 'L20613']
						)}
						{cardType == 'statistics' && (
							literals[countryData.check1 && 'L20714' || countryData.check2 && 'L20715' || countryData.check3 && 'L20716']
						)}
						{cardType == 'challenges' && (
							literals[countryData.check1 && 'L20631' || countryData.check2 && 'L20632' || countryData.check3 && 'L20633']
						)}
					</h3>				
					{cardType == 'institution' && (
						<React.Fragment>
							<div className="institution-name">
								{countryData.text1 && ReactHtmlParser(literals[`L${countryData.text1}`])}
							</div>
							<div>
								{countryData.text2 && ReactHtmlParser(literals[`L${countryData.text2}`])}
							</div>
							<div className="partial-text" >
								{this.state.selectedId == idCard ? (
									countryData.text3 && ReactHtmlParser(literals[`L${countryData.text3}`])
								) : (
									null
								)}
								{this.state.selectedId != idCard ? (
									countryData.text3 && ReactHtmlParser(this.truncateText(literals[`L${countryData.text3}`], 300))
								) : null}
							</div>
							<div className="complete-text">
								{ReactHtmlParser(literals[`L${countryData.text3}`])}
							</div>
						</React.Fragment>
					)}

					{(cardType == 'statistics' || cardType == 'challenges') && (
						<React.Fragment>
							<div>
								{ReactHtmlParser(literals[`L${countryData.text1}`])}
							</div>
							<div>
								{this.state.selectedId == idCard ? (
									ReactHtmlParser(literals[`L${countryData.text2}`])
								) : (
									null
								)}
								{this.state.selectedId != idCard ? (
									countryData.text2 && ReactHtmlParser(this.truncateText(literals[`L${countryData.text2}`], 350))
								) : (
									null
								)}
							</div>
						</React.Fragment>
					)}
					
					{(countryData.text3 && literals[`L${countryData.text3}`].length > 300 || countryData.text2 && replacedText.length > 350) && (
						<p className="see--more--wrapper" onClick={this.onToggleShowMore(idCard)}>
							{this.state.toggleShowMore ? <a className='see-less main-color'> {this.props.literals.L481} </a> : null }
							{!this.state.toggleShowMore ? <a className='see-more main-color'> {this.props.literals.L480} </a> : null }
						</p>
					)}

					{cardType == 'institution' && (
						<p><a onClick={this.onPDFClick(countryData.country.name)} className="btn--card main-color" target="_blank">{ReactHtmlParser(this.props.literals.L20563)}</a></p>
					)}
				</div>

				{cardType == 'challenges' && (
					<div>
						<p>
							<Link className="btn--card main-color" 
								to={{pathname: `/osh-steering/country-profile/basic-information/${this.props.countryData.country.code}`}} >{this.props.literals.L20626}</Link>
						</p>
					</div>
				)}				
			</React.Fragment>
		}
		else if (cardType == "publication")
		{
			const fullText = (countryData.text2) && literals[`L${countryData.text2}`]
			const replacedText = fullText && fullText.replace(/<\/?[a-z][a-z0-9]*[^<>]*>|<!--.*?-->/img);

			const publicationType = (
				literals[countryData.check1 && 'L20765' || countryData.check2 && 'L20766' || countryData.check3 && 'L20767' || countryData.check4 && 'L20768' || countryData.check5 && 'L20769' || countryData.check6 && 'L20770' || countryData.check7 && 'L20771']
			)
			
			cardContent = <React.Fragment>
					<div className="matrix--header--elements">
						<h2 className="country title-section main-color">{literals[`L${countryData.text1}`] }</h2>
					</div>
					<div className="matrix--content--elements">
						<div className='metadata-publication'>
							{ countryData.text3 ? (<p className='url'><strong>{literals.L20772}:</strong><a href={literals[`L${countryData.text3}`]} target='_blank' >{literals[`L${countryData.text3}`]}</a></p>) : (null) }
							<ul>
								{ countryData.text4 ? (<li><strong>{literals.L20773}:</strong>{literals[`L${countryData.text4}`]}</li>) : (null) }
								{ <li><strong>{literals.L20774}:</strong> {publicationType}</li> }
								{ countryData.text5 ? (<li><strong>{literals.L20775}:</strong> {literals[`L${countryData.text5}`]}</li>) : (null) }
							</ul>

						</div>
						<div>
							{this.state.selectedId == idCard ? (
								ReactHtmlParser(fullText)
							) : (
								null
							)}
							{this.state.selectedId != idCard ? (
								fullText && ReactHtmlParser(this.truncateText(fullText, 350))
							) : (
								null
							)}
						</div>
						{(replacedText && replacedText.length > 350) && (
							<p className="see--more--wrapper" onClick={this.onToggleShowMore(idCard)}>
								{this.state.toggleShowMore ? <a className='see-less main-color'> {this.props.literals.L481} </a> : null }
								{!this.state.toggleShowMore ? <a className='see-more main-color'> {this.props.literals.L480} </a> : null }
							</p>
						)}
						{ cardType == "organisation" && (<Link to={`/osh-infrastructure/international-programmes/${orgName}`}>{ this.props.literals.L20522 }</Link>) }
					</div>
				</React.Fragment>
		}
		else
		{
			const fullText = (countryData.text2 && countryData.text3) && literals[`L${countryData.text2}`]+literals[`L${countryData.text3}`]
			const replacedText = fullText && fullText.replace(/<\/?[a-z][a-z0-9]*[^<>]*>|<!--.*?-->/img);

			// Build the name of the organisation for the URL
			let orgName = literals[`L${countryData.text1}`];
			if (cardType == "organisation")
			{
				// If the code for the organisation is defined, it will be between parenthesis
				if (orgName != null && orgName.lastIndexOf("(") > -1)
				{
					let begin = orgName.lastIndexOf("(") + 1;
					let end = orgName.lastIndexOf(")");
					if (begin < end)
					{
						orgName = orgName.substring(begin, end);
					}
					else
					{
						orgName = orgName.substring(begin);
					}					
				}
				// Build the string for the URL
				orgName = orgName.toUpperCase().replaceAll(" ", "-")
			}
			cardContent = <React.Fragment>
					<div className="matrix--header--elements">
						<h2 className="country title-section main-color">{literals[`L${countryData.text1}`] }</h2>
					</div>
					<div className="matrix--content--elements">
						{cardType == "programme" && (
							<React.Fragment>
								<h3>{ literals[countryData.check1 && 'L20525' || countryData.check2 && 'L20526'] }</h3>
								<div className="institution-type">
									<span>{ this.props.literals.L20528 }</span>
									{ countryData.organisations.map((organisation, index) => {
										let orgName="";
										if (index > 0)
										{
											orgName = ", ";
										}
										orgName = orgName + this.props.literals[`L${organisation}`];

										return <span key={organisation}>{ orgName }</span>
									})}
								</div>
							</React.Fragment>							
						)}
						<div>
							{this.state.selectedId == idCard ? (
								ReactHtmlParser(fullText)
							) : (
								null
							)}
							{this.state.selectedId != idCard ? (
								fullText && ReactHtmlParser(this.truncateText(fullText, 350))
							) : (
								null
							)}
						</div>
						{(replacedText && replacedText.length > 350) && (
							<p className="see--more--wrapper" onClick={this.onToggleShowMore(idCard)}>
								{this.state.toggleShowMore ? <a className='see-less main-color'> {this.props.literals.L481} </a> : null }
								{!this.state.toggleShowMore ? <a className='see-more main-color'> {this.props.literals.L480} </a> : null }
							</p>
						)}
						{ cardType == "organisation" && (<Link to={`/osh-infrastructure/international-programmes/${orgName}`}>{ this.props.literals.L20522 }</Link>) }
					</div>
				</React.Fragment>
		}

        return (
			<div className="matrix--element clearfix">
				{ cardContent }
			</div>	
		)
    }
}

export default Cards;